import Marquee from "react-fast-marquee";
import { Flame } from "lucide-react";
import { BRANDS } from "@/data/site";

export const BrandsMarquee = ({ dark = false }) => (
  <div className={`py-10 border-y ${dark ? "border-white/10 bg-[#0B192C]" : "border-gray-200 bg-white"}`} data-testid="brands-marquee">
    <p className={`text-center text-xs font-heading font-bold uppercase tracking-[0.25em] mb-6 ${dark ? "text-white/40" : "text-gray-400"}`}>
      Factory-Trained On Every Major Brand
    </p>
    <Marquee speed={35} gradient={false} pauseOnHover>
      {BRANDS.concat(BRANDS).map((b, i) => (
        <span key={i} className={`flex items-center gap-3 mx-10 font-heading font-extrabold text-2xl sm:text-3xl tracking-tight ${dark ? "text-white/25" : "text-gray-300"}`}>
          <Flame className="w-5 h-5 text-[#FF6500]/40" /> {b}
        </span>
      ))}
    </Marquee>
  </div>
);
